import React from "react";
import { useSubscription } from "@apollo/client";
import { ON_TRANSACTION_CREATE_OR_UPDATE } from "../../../../graphql/graphql_transaction_linkcy/transaction/subscription";
import { transactionClient } from "../../../../apolloClient";
import { useCreateOrUpdateTransactionCache } from "../../../customHooks/transaction/tools";
import {
  OnTransactionCreateOrUpdate,
  OnTransactionCreateOrUpdateVariables,
} from "../../../../graphql/graphql_transaction_linkcy/transaction/types/OnTransactionCreateOrUpdate";
import { handleNotify } from "../../../NewNotification/DisplayNotification";
import { getInfoTransaction } from "../../../NewTransaction/logic";
import { useIntl } from "react-intl";
import { useAppSelector } from "../../../../redux/hook";

const TransactionSub = (props: { ledgerLinkcyId: string }) => {
  const { ledgerLinkcyId } = props;
  const { transactions } = useAppSelector((state) => state.transaction);
  const intl = useIntl();
  const { updateOrCreate } = useCreateOrUpdateTransactionCache();
  useSubscription<
    OnTransactionCreateOrUpdate,
    OnTransactionCreateOrUpdateVariables
  >(ON_TRANSACTION_CREATE_OR_UPDATE, {
    variables: {
      ledgerLinkcyId,
    },
    client: transactionClient,
    onSubscriptionData: ({ subscriptionData: { data } }) => {
      if (data?.onTransactionCreateOrUpdate) {
        updateOrCreate(data.onTransactionCreateOrUpdate);
        const { modalityText, name, type, amount } = getInfoTransaction(
          data.onTransactionCreateOrUpdate,
          ledgerLinkcyId,
        );
        const existing = transactions?.find(
          (t) => t?.id == data.onTransactionCreateOrUpdate?.id,
        );
        if (!existing)
          handleNotify({
            title: intl.formatMessage({ id: modalityText }),
            body: `${name} ${type === "credit" ? "+" : "-"} ${amount} `,
          });
      }
    },
  });

  return <></>;
};

export default TransactionSub;
